var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.727C20 5.447 16.431 2 12 2S4 5.447 4 9.727c0 3.506 5.366 9.502 7.309 11.557a.945.945 0 0 0 1.382 0C14.634 19.229 20 13.233 20 9.727M8.275 9.576c0-1.97 1.686-3.599 3.725-3.599s3.726 1.591 3.726 3.599c0 1.97-1.648 3.598-3.726 3.598-2.04 0-3.725-1.628-3.725-3.598"
  })));
};
export default SvgLocation;